import { render, staticRenderFns } from "./editItemReleaseViewList.vue?vue&type=template&id=10a4797d&scoped=true"
import script from "./editItemReleaseViewList.vue?vue&type=script&lang=js"
export * from "./editItemReleaseViewList.vue?vue&type=script&lang=js"
import style0 from "./editItemReleaseViewList.vue?vue&type=style&index=0&id=10a4797d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4797d",
  null
  
)

export default component.exports